export const orderStatusEnum = {
  Received: 26,
  Scheduled: 38,
  'Ready To Be Processed': 27,
  'Preparation Call And Itemization': 28,
  'Preparation Completed': 29,
  'Lab Assigned': 30,
  'Chemist Assigned': 31,
  'Chemist On His Way': 32,
  'Ready To Collect': 33,
  'Sample Collected': 34,
  'Sample Dropped': 35,
  'Results Sent': 36,
  Cancelled: 37,

  getKeyByValue(value) {
    return Object.keys(this).find(key => this[key] === value);
  },
};

export const orderStatusColorEnum = colors => ({
  [orderStatusEnum.Received]: {
    color: colors.white,
    backgroundColor: colors.greenMain,
  },
  [orderStatusEnum['Ready To Be Processed']]: {
    color: colors.black,
    backgroundColor: colors.grey004,
  },
  [orderStatusEnum['Preparation Call And Itemization']]: {
    color: colors.purpleDark,
    backgroundColor: colors.purpleLight,
  },
  [orderStatusEnum['Preparation Completed']]: {
    color: colors.white,
    backgroundColor: colors.greenDark,
  },
  [orderStatusEnum['Lab Assigned']]: {
    color: colors.white,
    backgroundColor: colors.purpleMain,
  },
  [orderStatusEnum['Chemist Assigned']]: {
    color: colors.white,
    backgroundColor: colors.purpleMain,
  },
  [orderStatusEnum['Chemist On His Way']]: {
    color: colors.redMain,
    backgroundColor: colors.redLight,
  },
  [orderStatusEnum['Ready To Collect']]: {
    color: colors.white,
    backgroundColor: colors.grey005,
  },
  [orderStatusEnum['Sample Collected']]: {
    color: colors.white,
    backgroundColor: colors.greenDark,
  },
  [orderStatusEnum['Sample Dropped']]: {
    color: colors.purpleDark,
    backgroundColor: colors.purpleLight,
  },
  [orderStatusEnum['Results Sent']]: {
    color: colors.white,
    backgroundColor: colors.greenMain,
  },
  [orderStatusEnum.Cancelled]: {
    color: colors.white,
    backgroundColor: colors.redDark,
  },
  [orderStatusEnum.Scheduled]: {
    color: colors.white,
    backgroundColor: colors.blueSkyDark,
  },
});

export const orderStatusToShowInFilter = [
  orderStatusEnum.Scheduled,
  orderStatusEnum['Ready To Be Processed'],
  orderStatusEnum['Preparation Call And Itemization'],
  orderStatusEnum['Chemist Assigned'],
  orderStatusEnum['Lab Assigned'],
  orderStatusEnum['Chemist On His Way'],
  orderStatusEnum['Ready To Collect'],
  orderStatusEnum['Sample Collected'],
  orderStatusEnum['Sample Dropped'],
  orderStatusEnum['Results Sent'],
];

export const orderStatusToShowInProgressBar = [
  orderStatusEnum.Received,
  orderStatusEnum['Ready To Be Processed'],
  orderStatusEnum['Preparation Call And Itemization'],
  orderStatusEnum['Preparation Completed'],
  orderStatusEnum['Lab Assigned'],
  orderStatusEnum['Chemist Assigned'],
  orderStatusEnum['Chemist On His Way'],
  orderStatusEnum['Ready To Collect'],
  orderStatusEnum['Sample Collected'],
  orderStatusEnum['Sample Dropped'],
  orderStatusEnum['Results Sent'],
];

export const orderStatusToEnableLabAssignMenu = [
  orderStatusEnum['Lab Assigned'],
  orderStatusEnum['Chemist Assigned'],
  orderStatusEnum['Chemist On His Way'],
  orderStatusEnum['Ready To Collect'],
  orderStatusEnum['Sample Collected'],
  orderStatusEnum['Sample Dropped'],
];

export const orderStatusToEnableEditInvoice = [
  orderStatusEnum['Preparation Call And Itemization'],
  orderStatusEnum['Ready To Collect'],
  orderStatusEnum['Sample Collected'],
];

export const orderStatusToShowUploadedResultsSection = [
  orderStatusEnum['Sample Dropped'],
  orderStatusEnum['Results Sent'],
];

export const orderAttachmentTypeEnum = {
  text: 'Text',
  image: 'Image',
};

export const orderResultsTypeEnum = {
  pdf: 'pdf',
  image: 'image',
};

export const promoCodeStatusEnum = {
  valid: 1,
  pending: 20,
};

export const promoCodeStatusPending = [promoCodeStatusEnum.valid, promoCodeStatusEnum.pending];

export const orderStatusToEnableAddingPromoCode = [
  orderStatusEnum['Preparation Call And Itemization'],
  orderStatusEnum['Ready To Collect'],
  orderStatusEnum['Sample Collected'],
];

export const hideButtonBasedOnState = {
  schedule: {
    [orderStatusEnum['Sample Collected']]: true,
    [orderStatusEnum['Sample Dropped']]: true,
    [orderStatusEnum['Results Sent']]: true,
    [orderStatusEnum.Cancelled]: true,
  },
  cancel: {
    [orderStatusEnum.Cancelled]: true,
  },
};
